<script setup lang="ts">
import {type LegacyActivityLog, usePhrases} from '@hantera/portal-app';
import {computed} from 'vue';

const props = defineProps<LegacyActivityLog>();
const message = usePhrases('legacyOrderView.activityLogs');

const displayUser = computed(() => {
  return !props.userId.startsWith('00000000');
});

var fields = props.fields.reduce<{ [name: string]: any }>((res, f) => {
  res[f.name] = f.value;
  return res;
}, {});

</script>

<template>
  <div class="activity-log">
    <div class="activity-log__message">{{ message(template, fields) }}</div>
  </div>
</template>

<style>
.activity-log {}

.activity-log__details {
  margin-bottom: 3px;
}

.activity-log__date {
  font-weight: 600;
}

.activity-log__user {
  margin-left: 10px;
  opacity: .5;
  font-weight: 300;
}
</style>